// Диагностика запуска с устройств, которые нечем воспроизвести у себя
// (iPhone/Safari): сервер пишет в лог, на каком шаге загрузки и с какой
// ошибкой остановилась игра. Если iOS убивает вкладку по памяти, событий
// уже не будет — тогда последний пришедший шаг и есть место падения.

// Шаги и ошибки считаются отдельно: прогресс загрузки не должен съедать
// лимит, пока до настоящей ошибки дело не дошло.
const MAX_STAGES = 40;
const MAX_OTHER = 30;
let sentStages = 0;
let sentOther = 0;
let lastStage = "";
const sid = Math.random().toString(36).slice(2, 8);
const t0 = performance.now();

export function diag(kind: string, msg: string): void {
  if (kind === "stage") {
    if (sentStages >= MAX_STAGES) return;
    sentStages++;
  } else {
    if (sentOther >= MAX_OTHER) return;
    sentOther++;
  }
  const body = JSON.stringify({
    sid, kind, t: Math.round(performance.now() - t0), msg: String(msg).slice(0, 500),
  });
  try {
    if (navigator.sendBeacon?.("/api/client-log", new Blob([body], { type: "text/plain" }))) return;
  } catch { /* ниже — запасной путь */ }
  try { void fetch("/api/client-log", { method: "POST", body, keepalive: true }).catch(() => {}); } catch { /* */ }
}

/** Шаг загрузки (текст лоадера) — только при смене текста. */
export function diagStage(text: string, pct?: number): void {
  // Счётчики вида «(38/289)» — это один и тот же шаг, а не новый.
  const base = text ? text.replace(/\s*\(\d+\/\d+\)/g, "").trim() : "";
  if (!base || base === lastStage) return;
  lastStage = base;
  diag("stage", pct === undefined ? base : `${base} ${Math.round(pct * 100)}%`);
}

export function installClientDiag(): void {
  addEventListener("error", (e) => {
    const where = e.filename ? ` @ ${e.filename.split("/").pop()}:${e.lineno}:${e.colno}` : "";
    diag("error", `${e.message || "error"}${where}`);
  });
  addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    diag("reject", r instanceof Error ? `${r.name}: ${r.message}` : String(r));
  });
  let gl = "нет";
  try {
    const c = document.createElement("canvas");
    const g = c.getContext("webgl2");
    if (g) gl = `webgl2 maxTex=${g.getParameter(g.MAX_TEXTURE_SIZE)}`;
  } catch { /* */ }
  // deviceMemory есть не везде (в Safari нет).
  const mem = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  diag("boot", `${innerWidth}x${innerHeight}@${devicePixelRatio} ${gl}${mem ? ` mem=${mem}GB` : ""}`);
}
